/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Runs_Column_CaseInputs */

const en_automation_runs_column_case = /** @type {(inputs: Automation_Runs_Column_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

const pt_br2_automation_runs_column_case = /** @type {(inputs: Automation_Runs_Column_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso`)
};

/**
* | output |
* | --- |
* | "Case" |
*
* @param {Automation_Runs_Column_CaseInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_runs_column_case = /** @type {((inputs?: Automation_Runs_Column_CaseInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Runs_Column_CaseInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_runs_column_case(inputs)
	return pt_br2_automation_runs_column_case(inputs)
});